<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          TC Order No：{{ formData.tcOrderNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.tcOrderStatus === 'Y' ||
            formData.tcOrderStatus === 'P' ||
            formData.tcOrderStatus === 'C'
              ? 'success'
              : formData.tcOrderStatus === 'D' || formData.tcOrderStatus === 'T'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_tcOrderStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="9">
          <el-form-item
            :label="$l('INDEX.order_form_label_scmCode') || '执行工厂'"
          >
            <el-input v-model="formData.scmName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('tc_order_info_tcInvoiceAmount') || 'TC开票金额'"
          >
            <el-input v-model="formData.v_tcInvoiceAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="
              $l('tc_order_info_tcFactoryPaymentTerms') || 'TC工厂付款条件'
            "
            prop="tcFactoryPaymentTerms"
          >
            <dict-select
              v-model="formData.tcFactoryPaymentTerms"
              url="/master/common/dict/biz"
              :body="paymentTermsParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="d-flex mt-2">
        <div class="side-frame-danger"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ '原订单信息' }}</span
          >
        </div>
      </div>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesPersonCode') || '业务人员'"
          >
            <el-input v-model="formData.salesPersonName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_bizPersonCode') || '跟单人员'"
          >
            <el-input v-model="formData.bizPersonName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderType') || '订单类型'"
          >
            <el-input v-model="formData.v_orderType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderSource') || '订单来源'"
          >
            <el-input v-model="formData.v_orderSource" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_issueType') || '下单方式'"
          >
            <el-input v-model="formData.v_issueType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesSeason') || '销售季节'"
          >
            <el-input v-model="formData.v_salesSeason" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_custCode') || '下单客户'"
          >
            <el-input v-model="formData.custName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_custOrderNo') || '客户订单编号'"
          >
            <el-input v-model="formData.custOrderNo" type="text" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.order_form_label_identifyNo') || '识别单号'"
          >
            <el-input v-model="formData.identifyNo" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_customerComfirmTime') || '客户下单日期'
            "
          >
            <el-input v-model="formData.customerComfirmTime" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_endCustCode') || '终端客户'"
          >
            <el-input v-model="formData.endCustName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_brand') || '品牌'">
            <el-input v-model="formData.brandName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_brandDepartment') || '品牌方部门'
            "
          >
            <el-input v-model="formData.brandDepartment" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_deliveryDay') || '交货日期'"
          >
            <el-input v-model="formData.deliveryDay" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_shipmentType') || '出运方式'"
          >
            <el-input v-model="formData.v_shipmentType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_deliveryPort') || '交货港口'"
          >
            <el-input v-model="formData.v_deliveryPort" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('INDEX.order_form_label_deliveryAddress') || '交货地址'"
          >
            <el-input v-model="formData.deliveryAddress" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_form_label_quotedMethod') || '报价方式'"
          >
            <el-input v-model="formData.v_quotedMethod" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_Total_order_cost') || '订单成本总价'
            "
          >
            <el-input v-model="formData.tcOrderAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_currencyUnit') || '成本货币单位'"
          >
            <el-input v-model="formData.tcCurrencyUnit" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('INDEX.order_form_label_paymentTerms') || '客户付款条件'"
          >
            <el-input v-model="formData.v_custPaymentTerms" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_importanceLevel') || '订单性质'"
          >
            <el-input v-model="formData.v_importanceLevel" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_settlementFactory') || '结算工厂(乙方)'
            "
          >
            <el-input v-model="formData.settlementFactoryName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_factoryPaymentTerms') || '工厂付款条件'
            "
          >
            <el-input v-model="formData.v_factoryPaymentTerms" readonly>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderScmCode') || '名义工厂(验厂工厂)'"
          >
            <el-input v-model="formData.orderScmName" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_importanceLevelDesc') || '订单性质说明'
            "
          >
            <el-input
              v-model="formData.importanceLevelDesc"
              type="textarea"
              rows="4"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('tc_order_info_tcOrderRemark') || 'TC订单备注说明'"
          >
            <el-input
              v-model="formData.tcOrderRemark"
              type="textarea"
              rows="4"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Review：{{ formData.reviewByName || '--' }} at
          {{ formData.reviewTime || '--' }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {},
  mixins: [EditLoading],
  props: {
    tcOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      paymentTermsParams: { dictType: 'paymentTerms' },
      formData: {},
      rules: {
        tcFactoryPaymentTerms: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.tcOrderCode) return
      this.$api
        .tcOrderInfoDetailApi({
          tcOrderCode: this.tcOrderCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()
      const res = await this.$api
        .tcOrderInfoUpdateApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 3px;
}
</style>
